module.exports = __webpack_public_path__ + "img/steam-en.126132f8.png";